// According to the Google Places API documentation - place types are limited to 5.
// See INVALID_REQUEST error cases:
// https://developers.google.com/maps/documentation/places/web-service/autocomplete#types

// Removed sublocality type in order to satisfy limit
export const GOOGLE_PLACES_DEFAULT_TYPES = 'locality|street_address|route|point_of_interest|plus_code';
